import { api } from '../client'
import type { RequestOptions } from '../client'
import type { CreateSourceRequest, RetrievalTrigger, Source, UpdateSourceRequest } from './types'

export const sourcesApi = {
  list: (options?: RequestOptions) => api.get<Source[]>('/sources', options),

  get: (id: number, options?: RequestOptions) => api.get<Source>(`/sources/${id}`, options),

  create: (body: CreateSourceRequest) => api.post<Source>('/sources', body),

  update: (id: number, body: UpdateSourceRequest) => api.patch<Source>(`/sources/${id}`, body),

  triggerRetrieval: (id: number) => api.post<RetrievalTrigger>(`/sources/${id}/retrievals`),
}

export type * from './types'
